import { DiscountType } from "@utils/enums";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";
import { PriceInfo } from "lib/@types/service/product/shared";

import { promotionMapper } from "./promotion.mapper";

const getAbsoluteAmount = (promoPrice: number, percentage: number) => {
    return Math.round(((promoPrice * percentage) / 100) * 100) / 100;
};

const getPriceAfterCashbackIsApplied = (
    product: FullProductApiModel,
    cashback: any | null,
) => {
    const promoPrice = product?.price?.currentPrice;

    if (promoPrice && cashback?.cashbackAmount) {
        if (cashback?.cashbackUnit === DiscountType.ABSOLUTE) {
            return promoPrice - cashback?.cashbackAmount;
        } else if (cashback?.cashbackUnit === DiscountType.PERCENTAGE) {
            const absoluteDiscount = getAbsoluteAmount(
                promoPrice,
                cashback.promotionPercent,
            );

            return promoPrice - absoluteDiscount;
        }
    }
    return null;
};

const priceMapper = (price: PriceInfo | null): PriceInfo | null => {
    if (!price) {
        return null;
    }

    return {
        ...(price || {}),
        roundedDiscountPercentage: price?.discountPercentage
            ? Math.floor(price?.discountPercentage)
            : null,
        promotions: (price?.promotions || []).map(promotionMapper),
    };
};

export { getPriceAfterCashbackIsApplied, priceMapper };
